const initialState = {
    isReadingAutocompleteResults: false,
    results: []
}

export default initialState;
